function _getImgInfo(src) {
    return new Promise(function (reslove, reject) {
        const img = new Image();
        img.onload = () => reslove({width: img.naturalWidth, height: img.naturalHeight});
        img.src = src;
        let check = setInterval(() => {
            if (img.naturalHeight > 0 || img.naturalWidth > 0) {
                reslove({width: img.naturalWidth, height: img.naturalHeight});
                clearInterval(check);
            }
        }, 40);
        img.onerror = err => {
            clearInterval(check);
            reject(err);
        };
    });
}

export const originLon = 10;
export const originLat = 6.5;
const originAspectScale = originLat / originLon;

async function _calLonLatArea(imgUrl) {
    let info = await _getImgInfo(imgUrl);
    let imgAspectScale = info.height / info.width;
    let lon = originLon;
    let lat = originLat;
    if (imgAspectScale > originAspectScale) {
        lon = originLat / info.height * info.width;
    } else if (imgAspectScale < originAspectScale) {
        lat = originLon / info.width * info.height;
    }
    info.lon = lon;
    info.lat = lat;
    info.aspectScale = imgAspectScale;
    return info;
}

export async function _getExtent(imgUrl) {
    let d = await _calLonLatArea(imgUrl);
    return {
        info: d,
        extent: [-d.lon, -d.lat, d.lon, d.lat]
    };
}

export async function _getBoundingCoords(imgUrl) {
    let d = await _calLonLatArea(imgUrl);
    return {
        info: d,
        bounding: [
            [-d.lon, d.lat],
            [d.lon, -d.lat]
        ]
    };
}

export function _generateDownloadUrl(val) {
    return process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=" + val;
}